import styled, { css } from 'styled-components'
import { media } from '../../styles/_variables'

export const ImgBg = styled.div`
  position: absolute;
  top: 12px;
  left: 12px;
  right: 12px;
  bottom: 12px;
  transition: all 0.5s ease;
  transform: scale(1.1);
  ${props => props.img && css`
    background-image: url(${props.img});
    background-size: cover;
    background-position: center;
  `}
`

export const ImageWrapper = styled.div`
  width: calc((100% - 72px) / 3);
  padding-top: calc((100% - 72px) / 3);
  margin: 12px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0);
    transition: all 0.5s ease;
    z-index: 2;
  }
  &:after {
    content: '';
    position: absolute;
    top: 16px;
    bottom: 16px;
    left: 16px;
    right: 16px;
    border: 1px solid rgba(255, 255, 255, 0.7);
    opacity: 0;
    transition: all 0.5s ease;
    z-index: 3;
  }
  > i {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 32px;
    color: rgba(255, 255, 255, 0.8);
    opacity: 0;
    transition: all 0.5s ease;
    z-index: 3;
  }
  &:hover {
    &:before {
      background-color: rgba(0, 0, 0, 0.5);
    }
    &:after {
      opacity: 1;
    }
    > ${ImgBg} {
      transform: scale(1.2);
    }
    > i {
      opacity: 1;
    }
  }
  ${media.tablet`
    margin: 8px;
    width: calc((100% - 48px) / 3);
    padding-top: calc((100% - 48px) / 3);
  `}
  ${media.tabletS`
    margin: 8px;
    width: calc((100% - 32px) / 2);
    padding-top: calc((100% - 32px) / 2);
  `}
`

export default ImageWrapper



// WEBPACK FOOTER //
// ./src/pages/gallery/styled.js